import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";

export const controlsStyle = css`
    padding-bottom: ${Spacing.SM}px;
    @media (max-width: 900px) {
        max-width: 300px;
        margin-right: auto;
        padding: 0;
        flex-direction: column;
        align-items: baseline;
        .sds-button {
            width: 200px;
            margin: ${Spacing["1XS"]}px 0;
            :first-of-type {
                margin-top: ${Spacing.SM}px;
            }
            :last-child {
                margin-bottom: ${Spacing.SM}px;
            }
        }
    }
`;

export const currentLensStyle = css`
    @media (max-width: 900px) {
        padding: 0;
        margin-top: 0.5rem;
    }
`;

export const inputStyle = css`
    padding: 0 1rem;

    @media (max-width: 900px) {
        padding: 0 0 1rem 0;
    }
`;

export const submitStyle = css`
    @media (min-width: 900px) {
        height: 80px;
    }
`;
